import { toggleMenu } from "./header";
import { scrollToHash, getSamePageAnchor } from "./smooth-scrolling";
import '../css/main.css';


document.addEventListener("DOMContentLoaded", () => {
  /**
   * Toggle del header
   */
  toggleMenu()

  /**
   * Platform carousel
   */
  const platformCarousel = document.querySelectorAll(".platform-carousel");
  if (platformCarousel.length > 0) {
    import("./platform-carousel").then((module) => {
      platformCarousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Methodology carousel
   */
  const methodologyCarousel = document.querySelectorAll(".methodology-carousel");
  if (methodologyCarousel.length > 0) {
    import("./methodology-carousel").then((module) => {
      methodologyCarousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Team carousel
   */
  const teamCarousel = document.querySelectorAll(".team-carousel");
  if (teamCarousel.length > 0) {
    import("./team-carousel").then((module) => {
      teamCarousel.forEach((slider) => {
        module.carousel(slider);
      });
    });
  }

  /**
   * Smooth scrolling support
   */
  // If a link's href is within the current page, scroll to it instead
  document.querySelectorAll('a[href]').forEach(a => {
    a.addEventListener('click', e => {
      scrollToHash(getSamePageAnchor(a), e);
    });
  });
  // Scroll to the element in the URL's hash on load
  scrollToHash(window.location.hash);

  /**
   * ACF7 event listener
   */
  document.addEventListener('wpcf7mailsent', (event) => {
    gtag('event', 'Formulario', {
      'event_category': event.detail.contactFormId,
      'event_label': event.detail.unitTag
    });
  }, false);

  const hero = document.querySelectorAll(".block__portada");
  // if (hero.length > 0) {
  //   import("./masonry").then((module) => {
  //     console.log("🚀 ~ module:", module)
  //     hero.forEach((block) => {
  //       const elem = block.querySelector(".col-span-full");
  //       module.initMasonry(elem);
  //     });
  //   });
  // }

  const productsBlock = document.querySelectorAll(".block__paquetes");
  if (productsBlock.length > 0) {
    import("./products").then((module) => {
      productsBlock.forEach((block) => {
        module.handleToggle(block);
      });
    });
  }

  /**
   * DNI validation – soporta que el campo aparezca después (bloques WC)
   */
  const DNI_SELECTOR = '#billing-thwcfe-block-dni';

  const attachDniValidation = (dniInput) => {
    if (!dniInput || dniInput.dataset.dniValidationBound === 'true') return;
    dniInput.dataset.dniValidationBound = 'true';

    import("./dni-validator").then((module) => {
      module.setupDniValidation(dniInput);
    });
  };

  // 1) Intento inicial (por si ya está en el DOM)
  const initialDniInput = document.querySelector(DNI_SELECTOR);
  if (initialDniInput) {
    attachDniValidation(initialDniInput);
  }

  // 2) Observer para cuando WC Blocks renderiza el checkout
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches && node.matches(DNI_SELECTOR)) {
          attachDniValidation(node);
        } else {
          const nested = node.querySelector?.(DNI_SELECTOR);
          if (nested) {
            attachDniValidation(nested);
          }
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('change', (e) => {
    if (!e.target.matches('.trial-toggle')) return;

    const ui = document.getElementById(e.target.dataset.toggleTarget);
    if (!ui) return;

    const knob = ui.querySelector('.knob');

    if (e.target.checked) {
      ui.classList.remove('bg-gray-300');
      ui.classList.add('bg-primary');
      knob.classList.add('translate-x-5');
    } else {
      ui.classList.add('bg-gray-300');
      ui.classList.remove('bg-primary');
      knob.classList.remove('translate-x-5');
    }
  });

  const heroButton = document.getElementById("heroButton");
  if (heroButton) {
    heroButton.addEventListener("click", () => {
      Calendly.initPopupWidget({
        url: 'https://calendly.com/seguimientopn/nueva-reunion-clon'
      });
    });
  }
});

